import { render, staticRenderFns } from "./LossRate.vue?vue&type=template&id=08044b5e&"
import script from "./LossRate.vue?vue&type=script&lang=js&"
export * from "./LossRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports